<flx-resources-grid
  [tableDef]="triggerTableColumns"
  [items]="rowData()"
  emptyMsg="No trigger"
  emptyMsgDescription="Instances started by an event, such as an incoming email, show that trigger here."
/>
